export default __webpack_public_path__ + "static/media/Wellington Nogueira Dr. Zinho-1.b70efb1d.png";